import { tns } from 'tiny-slider/src/tiny-slider'

// Cases
export function caseSlider (el) {
	const element = document.querySelector(el)
	// don't start function if the element is not on the page
	if (!element) return
	const slider = tns({
		container: el,
		items: 1,
		nav: false,
		controlsContainer: element.nextElementSibling,
		autoplay: false,
		mouseDrag: true,
		autoHeight: true
	})
}

// Teamslider
export function teamSlider (el) {
	const element = document.querySelector(el)
	// don't start function if the element is not on the page
	if (!element) return
	const slider = tns({
		container: el,
		responsive: {
			0: {
				items: 1,
				edgePadding: 100,
				startindex: 2,
				gutter: 10
			},
			768: {
				items: 4,
				startindex: 0,
				edgePadding: 0,
				gutter: 0
			},
			960: {
				items: 6
			},
			1500: {
				items: 8
			},
			1900: {
				items: 10
			}
		},
		mouseDrag: true,
		// autoplay: true,
		autoplayButtonOutput: false,
		loop: true,
		autoHeight: true,
		// autoplayTimeout: 7500,
		controls: false,
		nav: false,
		slideBy: 1
	})
	document.querySelector('.team .next').addEventListener('click', () => slider.goTo('next'))
}
// Clientsslider
export function clientsSlider (el) {
	const element = document.querySelector(el)
	// don't start function if the element is not on the page
	if (!element) return
	const slider = tns({
		container: el,
		responsive: {
			0: {
				items: 1,
				edgePadding: 100,
				startindex: 2,
				gutter: 10
			},
			768: {
				items: 4,
				startindex: 0,
				edgePadding: 100,
				gutter: 10
			},
			960: {
				items: 6,
				edgePadding: 100,
				gutter: 10
			},
			1500: {
				items: 6,
				edgePadding: 100,
				gutter: 10
			},
			1900: {
				items: 6,
				edgePadding: 100,
				gutter: 10
			}
		},
		mouseDrag: true,
		autoplay: true,
		autoplayButtonOutput: false,
		loop: true,
		autoHeight: true,
		// autoplayTimeout: 7500,
		controls: false,
		nav: false,
		slideBy: 1
	})
	document.querySelector('.clients .next').addEventListener('click', () => slider.goTo('next'))
}
